function n(n){return void 0===n&&(n=[]),n.filter((function(n){return!!n&&n.length})).join(" ")}export{n as joinClassNames};
